import { useContext } from "react";
import { useParams } from "react-router";

import { UserContext } from "@/contexts/user/UserContext";

function useOrganizationId(): number | undefined {
  const { organizationId: organizationIdParam } = useParams<{
    organizationId?: string;
  }>();
  const { user } = useContext(UserContext);

  if (organizationIdParam) {
    const parsedOrganizationId = Number(organizationIdParam);
    if (!Number.isNaN(parsedOrganizationId)) {
      return parsedOrganizationId;
    }
  }

  return user?.organizationId;
}

export { useOrganizationId };
